/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */

import { createTheme } from '@cld/component-theme';
import { iconTheme } from '@cld/icon';

export const theme = createTheme(
  {
    height: '48px',
    icon: {
      size: iconTheme.sm,
    },
  },
  'folder-card'
);
